'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactRedux = require("react-redux");

var _lodash = _interopRequireDefault(require("lodash.assign"));

var _lodash2 = _interopRequireDefault(require("lodash.isequal"));

var _lodash3 = _interopRequireDefault(require("lodash.foreach"));

var _lodash4 = _interopRequireDefault(require("lodash.debounce"));

var _inViewport = _interopRequireDefault(require("in-viewport"));

var _actions = require("./actions");

var _conf = _interopRequireWildcard(require("../../conf"));

var _translate = _interopRequireDefault(require("../translate"));

var _searchField = _interopRequireDefault(require("../search-field"));

var _searchResults = _interopRequireDefault(require("../search-results"));

var _searchResultsFilter = _interopRequireDefault(require("../search-results-filter"));

var _navigation = _interopRequireDefault(require("../navigation"));

var _searchPlaceInfo = _interopRequireDefault(require("../search-place-info"));

var _footer = _interopRequireDefault(require("../footer"));

var _advancedFetch = _interopRequireDefault(require("../advanced-fetch"));

var _metadata = _interopRequireDefault(require("../../lib/metadata"));

var _loader = _interopRequireDefault(require("../loader"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

var initialFilters = function initialFilters() {
  return {
    canton: [],
    membership: [],
    productionType: [],
    productionlabels: [],
    productiontype: [],
    project: [],
    soldOut: [],
    soldout: [],
    lgwProduct: [],
    lgwDeliveryType: [],
    products: [],
    vacation: []
  };
};

var extractFilterFromUrl = function extractFilterFromUrl(search, t) {
  var filtersToSet = initialFilters();
  var filtersFromUrl = search.replace('?', '').split('&');
  filtersFromUrl = filtersFromUrl.filter(function (filter) {
    var parameter = filter.split('=')[0];
    var value = filter.split('=')[1];

    if (value === 'lgw') {
      filtersToSet.lgwProduct = [];
      filtersToSet.lgwDeliveryType = [];
    }

    if (parameter.indexOf('iframe') !== -1) {
      return false;
    }

    if (parameter.indexOf('extSearch') !== -1) {
      return false;
    }

    return true;
  }); // loop through each set of filters

  filtersFromUrl.forEach(function (filter) {
    var parameter = filter.split('=')[0];
    var filterValues = filter.replace(parameter, '').replace('=', '').split(',');
    filterValues.forEach(function (filterValue) {
      var value = decodeURIComponent(filterValue);
      var filterKey;

      if (parameter === 'project') {
        filterKey = _conf.default.projectKeys[value];
        value = t("".concat(value, "-filter-value"));
      } //parameter naming has to be fixed for some filters


      switch (parameter) {
        case 'projects':
          parameter = 'project';
          break;
      }

      if (filtersToSet[parameter] !== undefined) {
        filtersToSet[parameter].push({
          value: value,
          parameterName: parameter,
          filterKey: filterKey
        });
      }
    });
  });
  return filtersToSet;
};

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  /**
   *
   * @param props
   */
  function Search(props) {
    var _this;

    _classCallCheck(this, Search);

    _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));
    _this.theme = document.body.classList.item(0);
    var hasSearched = false;

    if (_this.props.history.location.hash && _this.props.history.location.hash !== '#home') {
      hasSearched = true;
    }

    if (props.farms && props.farms.length > 0) {
      hasSearched = true;
    }

    _this.state = {
      search: '',
      coordinates: props.coordinates,
      viewportOffsetVisible: true,
      modalOpen: false,
      filters: {
        canton: [],
        project: [],
        productionType: [],
        products: [],
        vacation: []
      },
      locationShareError: null,
      filteredLocations: [],
      detailViewPath: '',
      detailViewSearch: '',
      canton: [],
      hasSearched: hasSearched,
      noHomepage: false
    };

    if (document.body.className !== 'landwirtschaft') {
      _this.state.noHomepage = true;
    }

    if (_this.props.extSearch.isExtSearch) {
      _this.state.search = _this.props.extSearch.query.q;
    }

    if (props.search && props.search.length > 0) {
      _this.state.search = props.search;
    }

    if (props.history.location.search.length > 0) {
      _this.state.filters = extractFilterFromUrl(props.history.location.search, props.t);
    }

    _this.onSearchForPlace = _this.onSearchForPlace.bind(_assertThisInitialized(_this));
    _this.search = _this.search.bind(_assertThisInitialized(_this));
    _this.onSearch = _this.onSearch.bind(_assertThisInitialized(_this));
    _this.onLoadMore = _this.onLoadMore.bind(_assertThisInitialized(_this));
    _this.setFilters = _this.setFilters.bind(_assertThisInitialized(_this));
    _this.checkViewportOffsetVisible = _this.checkViewportOffsetVisible.bind(_assertThisInitialized(_this));
    _this.scrollToListStart = _this.scrollToListStart.bind(_assertThisInitialized(_this));
    _this.getNumberOfResults = _this.getNumberOfResults.bind(_assertThisInitialized(_this)); //this.scrollIntoView = this.scrollIntoView.bind(this);

    _this.checkLocationShareError = _this.checkLocationShareError.bind(_assertThisInitialized(_this));
    _this.filterLocationsByProject = _this.filterLocationsByProject.bind(_assertThisInitialized(_this));
    _this.handleInputChange = _this.handleInputChange.bind(_assertThisInitialized(_this));
    _this.onHistoryChange = _this.onHistoryChange.bind(_assertThisInitialized(_this));
    _this.resetAllFilters = _this.resetAllFilters.bind(_assertThisInitialized(_this));
    _this.removeFilter = _this.removeFilter.bind(_assertThisInitialized(_this));
    _this.setBrunchSoldout = _this.setBrunchSoldout.bind(_assertThisInitialized(_this));
    _this.getFilterCount = _this.getFilterCount.bind(_assertThisInitialized(_this));
    _this.goBackToHome = _this.goBackToHome.bind(_assertThisInitialized(_this));
    _this.searchSuggestions = (0, _lodash4.default)(_this.searchSuggestions.bind(_assertThisInitialized(_this)), 200);
    _this.viewportOffsetEndRef = _react.default.createRef();
    _this.viewportOffsetStartRef = _react.default.createRef();
    _this.jumpMarkPixel = _react.default.createRef();
    return _this;
  }
  /**
   *
   */


  _createClass(Search, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      // Do not add the event listener immediately.
      // Wait for the animation, that is triggered on page switch, to prevent scrolling issues.
      setTimeout(function () {
        window.addEventListener('scroll', _this2.checkViewportOffsetVisible);
      }, 500);
      this.unlisten = this.props.history.listen(this.onHistoryChange);
      var filterLength = Object.entries(this.props.activeFilter).length;

      if (this.props.history.location.search.length > 1 && filterLength === 0) {
        this.onHistoryChange();
      }

      if (this.props.history.location.hash && this.props.history.location.hash !== '#home' || this.state.noHomepage) {
        this.setState({
          hasSearched: true
        }, function () {
          if (!_this2.props.farms || _this2.props.farms.length === 0) {
            _this2.onHistoryChange(true);
          }
        });
      }

      this.setState(function (prev) {
        prev.hash = _this2.props.history.location.hash;
      });
      var hash = this.props.history.location.hash;

      if (!hash) {
        window.scrollTo(0, 0);
        return;
      }

      var element = document.getElementById(hash.replace('#', ''));
      if (!element) return;
      if (element.scrollIntoView) element.scrollIntoView({
        block: 'center',
        'behavior': 'smooth'
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this3 = this;

      if (this.state.filteredLocations.length <= 0) {
        if (this.theme !== 'landwirtschaft') {
          this.filterLocationsByProject();
        }
      }

      if (this.props.coordinates !== prevProps.coordinates) {
        this.setState(function (prev) {
          prev.coordinates = _this3.props.coordinates;
          return prev;
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.checkViewportOffsetVisible);
      this.unlisten();
    }
    /**
     *
     * @returns {*}
     */

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          t = _this$props.t,
          totalFarms = _this$props.totalFarms,
          iframe = _this$props.iframe,
          placeSearch = _this$props.placeSearch;
      var farms = this.props.farms;
      var hasMore = false,
          showEnd = false;
      var endMessage = '';

      if (farms) {
        hasMore = farms.length < totalFarms;
        showEnd = farms.length === 0;
      }

      var searchClass = iframe.isIframe ? 'search--iframe' : '',
          theme = document.body.classList.item(0);
      (0, _metadata.default)(t("".concat(theme, " | Hofsuche")), t("".concat(theme, " | metadescription")));
      var placeholderKey = 'placeholder' + ' ' + theme;

      if (showEnd) {
        endMessage = /*#__PURE__*/_react.default.createElement("span", {
          style: {
            textAlign: 'center',
            display: 'block'
          },
          className: 'no-farms-found'
        }, t('Keine weiteren Höfe gefunden'));
      }

      if (this.state.locationShareError) {
        endMessage = /*#__PURE__*/_react.default.createElement("p", {
          style: {
            textAlign: 'center'
          }
        }, /*#__PURE__*/_react.default.createElement("b", null, t(this.state.locationShareError)));
        farms = null;
        hasMore = false;
      }

      var showLoadMore = true;

      if (!farms || farms.length === 0) {
        showLoadMore = false;
      }

      if (!hasMore) {
        showLoadMore = false;
      }

      var enableLoadMore = true;

      if (this.props.searchInProgress) {
        enableLoadMore = false;
        showLoadMore = false;
        showEnd = false;
      }

      var boxColors = ['green', 'white', 'blue', 'lightgreen', 'lightblue'];
      var showBrunchSoldout = false;

      if (this.state.filters && this.state.filters.project && this.state.filters.project.length === 1 && this.state.filters.project[0].value.match(/brunch/i)) {
        showBrunchSoldout = true;
      }

      var showHome = false;

      if (!this.state.noHomepage) {
        showHome = !this.state.hasSearched;
      }

      if (!showHome) {
        searchClass += ' has-searched ';
      }

      if (showBrunchSoldout) {
        searchClass += ' show-brunch-soldout';
      }

      var projects = ['brunch', 'stallvisite', 'lockpfosten', 'vomhof'];

      if (this.props.i18n.language === 'en') {
        projects = ['brunch', 'stallvisite', 'vomhof'];
      }

      return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, !iframe.isIframe ? /*#__PURE__*/_react.default.createElement(_navigation.default, {
        theme: this.theme,
        history: this.props.history,
        hasSearched: !showHome,
        goBack: this.goBackToHome,
        alwaysLinkExternal: this.state.noHomepage
      }) : '', /*#__PURE__*/_react.default.createElement("div", {
        className: "search ".concat(searchClass)
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: 'search-header'
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-title-wrapper"
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "search-title",
        ref: this.viewportOffsetStartRef
      }, t('Suchen Sie nach Bauernhöfen'))), /*#__PURE__*/_react.default.createElement(_searchField.default, {
        t: t,
        search: this.state.search,
        suggestions: this.props.suggestions,
        placeholder: t(placeholderKey),
        label: t('Search by farm name, product, project ...'),
        onSearch: this.onSearch,
        viewportOffsetVisible: this.state.viewportOffsetVisible,
        numberOfResults: this.getNumberOfResults(),
        locations: this.props.locations,
        history: this.props.history,
        setFilters: this.setFilters,
        activeFilters: this.state.filters,
        scrollToListStart: this.scrollToListStart,
        checkLocationShareError: this.checkLocationShareError,
        onPlaceSearch: this.onSearchForPlace,
        theme: this.theme,
        handleInputChange: this.handleInputChange,
        getFilterCount: this.getFilterCount,
        hasSearched: !showHome,
        showMap: this.props.showMap,
        offersAvailability: this.props.offersAvailability
      })), showHome && /*#__PURE__*/_react.default.createElement("div", {
        className: 'project-boxes'
      }, projects.map(function (key, index) {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: key,
          className: 'box-row'
        }, /*#__PURE__*/_react.default.createElement("div", {
          className: 'box-image'
        }, /*#__PURE__*/_react.default.createElement("img", {
          src: "/static/assets/images/home-boxes/".concat(key).concat(key === 'lockpfosten' ? "-".concat(_this4.props.i18n.language) : '', ".jpg")
        })), /*#__PURE__*/_react.default.createElement("div", {
          className: "box-text ".concat(boxColors[index])
        }, /*#__PURE__*/_react.default.createElement("h2", null, t("box-header-".concat(key))), /*#__PURE__*/_react.default.createElement("p", null, t("box-text-".concat(key)))));
      })), !showHome && /*#__PURE__*/_react.default.createElement("div", {
        className: "result-wrapper"
      }, /*#__PURE__*/_react.default.createElement(_searchPlaceInfo.default, {
        show: placeSearch.show,
        name: placeSearch.name,
        texts: {
          introduction: t('placesearch introduction', {
            place: placeSearch.name
          }),
          startSearch: t('placesearch start')
        },
        startSearch: function startSearch() {
          return _this4.onSearchForPlace(placeSearch.lon, placeSearch.lat);
        }
      }), farms === null ? '' : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement(_searchResultsFilter.default, {
        filters: this.state.filters,
        removeFilter: this.removeFilter
      }), /*#__PURE__*/_react.default.createElement(_searchResults.default, {
        detailViewPath: this.state.detailViewPath,
        detailViewSearch: this.state.detailViewSearch,
        theme: theme,
        setBrunchSoldout: this.setBrunchSoldout,
        showBrunchSoldout: showBrunchSoldout,
        history: this.props.history,
        numberOfResults: this.props.totalFarms,
        filters: this.state.filters,
        farms: farms
      })), this.props.searchInProgress && /*#__PURE__*/_react.default.createElement(_loader.default, null), /*#__PURE__*/_react.default.createElement("div", {
        className: 'load-more-wrapper'
      }, showLoadMore && /*#__PURE__*/_react.default.createElement("button", {
        className: 'load-more' + (enableLoadMore ? '' : ' disabled '),
        onClick: enableLoadMore ? this.onLoadMore : function () {
          return null;
        }
      }, t('load-more'))), showEnd && endMessage), /*#__PURE__*/_react.default.createElement(_footer.default, {
        searchSuggestions: this.searchSuggestions,
        history: this.props.history,
        isHome: showHome
      }))));
    }
    /**
     *
     */

  }, {
    key: "goBackToHome",
    value: function goBackToHome() {
      var _this5 = this;

      setTimeout(function () {
        _this5.setState({
          hasSearched: false
        }, function () {
          _this5.setFilters({}, true);
        });
      }, 50);
    }
    /**
     *
     */

  }, {
    key: "filterLocationsByProject",
    value: function filterLocationsByProject() {
      var _this6 = this;

      this.setState(function (prev) {
        prev.filteredLocations = _this6.props.allLocations.filter(function (location) {
          return location[_this6.theme];
        });
      });
    }
    /**
     *
     */

  }, {
    key: "onSearch",
    value: function onSearch(value, setFilterFromSuggestions) {
      var _this7 = this;

      var valueSearch = value; // check if the value is available as a product or vacation

      var hasVacation = this.props.vacation ? this.props.vacation.some(function (v) {
        return v.name === value;
      }) : false;
      var hasProduct = this.props.product ? this.props.product.some(function (product) {
        return product.name === value;
      }) : false;

      if (!hasVacation && !hasProduct) {
        setFilterFromSuggestions = false;
      } // check if user clicked on suggestion and set it as filter


      if (setFilterFromSuggestions) {
        var parameterName = 'products';

        if (hasVacation) {
          parameterName = 'vacation';
        }

        var filterFromSuggestion = Object.assign({}, this.state.filters);
        valueSearch = '';

        if (!Array.isArray(filterFromSuggestion.products)) {
          filterFromSuggestion.products = [];
        }

        if (!Array.isArray(filterFromSuggestion.vacation)) {
          filterFromSuggestion.vacation = [];
        }

        filterFromSuggestion[parameterName].push({
          value: value,
          parameterName: parameterName
        });
        this.setState({
          filters: filterFromSuggestion
        });
        this.setFilters(this.state.filters);
      }

      this.setState(function (prev) {
        prev.coordinates = null;
        prev.search = valueSearch;
        prev.locationShareError = null;
        return prev;
      }, function () {
        _this7.props.dispatch((0, _actions.startSearch)(valueSearch));

        _this7.search(false, true).then(_this7.scrollToListStart);
      });
    }
    /**
     *
     */

  }, {
    key: "onLoadMore",
    value: function onLoadMore() {
      this.search(true);
    }
  }, {
    key: "onSearchForPlace",
    value: function onSearchForPlace(lon, lat) {
      var _this8 = this;

      var sendQueryString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
      this.setState(function (prev) {
        prev.coordinates = {
          lon: lon,
          lat: lat
        };
        prev.locationShareError = null;
        return prev;
      }, function () {
        return _this8.search(false, true, sendQueryString).then(function () {
          _this8.scrollToListStart();
        }).catch(function (err) {
          return void 0;
        });
      });
    }
  }, {
    key: "checkLocationShareError",
    value: function checkLocationShareError(error) {
      this.setState({
        locationShareError: error
      });

      switch (error.code) {
        case error.PERMISSION_DENIED:
          this.setState({
            locationShareError: 'Kein Zugriff auf Standort möglich.'
          });
          this.search().then(this.scrollToListStart);
          break;

        case error.POSITION_UNAVAILABLE:
          this.setState({
            locationShareError: 'Kein Zugriff auf Standort möglich.'
          });
          this.props.farms = null;
          this.search().then(this.scrollToListStart);
          break;
      }
    }
    /**
     *
     */

  }, {
    key: "searchSuggestions",
    value: function searchSuggestions(search) {
      var _this9 = this;

      var i18n = this.props.i18n;
      var queryOptions = {};
      queryOptions.language = i18n.language;
      queryOptions.query = search;
      queryOptions.filters = this.state.filters;
      var theme = document.body.classList.item(0);

      if (queryOptions.filters.project) {
        // try again later, we need project filter
        queryOptions.filters = (0, _lodash.default)({}, queryOptions.filters);
        queryOptions.filters.project = queryOptions.filters.project.map(function (project) {
          var projectToSearch = _this9.props.project;
          var propProject = projectToSearch.find(function (propProject) {
            return propProject.value === project.value;
          });

          if (!propProject) {
            return null;
          }

          return {
            parameterName: project.parameterName,
            value: propProject.filterKey
          };
        }).filter(function (filter) {
          return !!filter;
        });
      }

      if (search.length === 0) {
        return null;
      }

      return this.props.dispatch((0, _actions.searchSuggestions)(queryOptions, theme));
    }
    /**
     *
     */

  }, {
    key: "search",
    value: function search() {
      var _this10 = this;

      var loadMore = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var resetOffset = arguments.length > 1 ? arguments[1] : undefined;
      var sendQueryString = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var _this$props2 = this.props,
          i18n = _this$props2.i18n,
          farms = _this$props2.farms;
      var queryOptions = {};
      var offset = farms && farms.length || 0;

      if (resetOffset) {
        offset = 0;
      }

      this.setState({
        hasSearched: true
      });

      if (this.state.coordinates) {
        queryOptions.lon = this.state.coordinates.lon;
        queryOptions.lat = this.state.coordinates.lat;
      }

      queryOptions.query = this.state.search;

      if (!sendQueryString) {
        queryOptions.query = '';
      }

      queryOptions.language = i18n.language;
      queryOptions.size = _conf.search.itemsPerPage;
      queryOptions.offset = offset;
      queryOptions.filters = this.state.filters;
      queryOptions.preFilters = this.props.iframe.query;

      if (queryOptions.filters.project) {
        // try again later, we need project filter
        if (!this.props.project || this.props.project.length > 0 && this.props.project[0].language !== i18n.language) {
          return new Promise(function (resolve) {
            setTimeout(function () {
              resolve(_this10.search(loadMore, resetOffset, sendQueryString));
            }, 50);
          });
        }

        queryOptions.filters = (0, _lodash.default)({}, queryOptions.filters);
        queryOptions.filters.project = queryOptions.filters.project.map(function (project) {
          var projectToSearch = _this10.props.project;
          var propProject = projectToSearch.find(function (propProject) {
            return propProject.value === project.value;
          });

          if (!propProject) {
            return null;
          }

          return {
            parameterName: project.parameterName,
            value: propProject.filterKey
          };
        }).filter(function (filter) {
          return !!filter;
        });
      }

      window.dataLayer.push({
        'event': loadMore ? 'scroll' : 'search',
        'data': queryOptions
      });
      return this.props.dispatch((0, _actions.search)(queryOptions, loadMore, this.state.detailViewSearch, this.state.detailViewPath));
    }
    /**
     *
     * @param e
     */

  }, {
    key: "onHistoryChange",
    value: function onHistoryChange() {
      var _this11 = this;

      var forceSearch = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var history = this.props.history;

      if (history.location.pathname.match(/\/farm\//)) {
        return;
      }

      var pathArray = history.location.pathname.split('/');

      if (['de', 'fr', 'it', 'en'].indexOf(pathArray[1]) !== -1 && pathArray[1] !== this.props.i18n.language) {
        (0, _advancedFetch.default)('/api/change-language', {
          credentials: 'include',
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            lang: pathArray[1]
          })
        }).then(function () {
          _this11.props.i18n.changeLanguage(pathArray[1], function (err) {
            _this11.onHistoryChange(forceSearch);
          });
        });
        return;
      }

      var hasSearched = true;

      if (this.props.history.location.hash === '#home') {
        hasSearched = false;
      }

      if (this.props.history.location.search.length > 0) {
        // split url into parts of values + parameters
        var filtersToSet = extractFilterFromUrl(this.props.history.location.search, this.props.t);
        this.setState({
          filters: filtersToSet,
          detailViewSearch: this.props.history.location.search,
          detailViewPath: this.props.history.location.pathname
        }, function () {
          if (hasSearched) {
            _this11.search(false, true).then(function () {
              _this11.scrollToListStart();
            }).catch(function (err) {
              return void 0;
            });
          }
        });
      } else if (hasSearched) {
        // reset filters
        this.setState({
          filters: initialFilters()
        }, function () {
          if (forceSearch || hasSearched && _this11.props.farms && _this11.props.farms.length > 0) {
            _this11.search(false, true).then(_this11.scrollToListStart);
          }
        });
      }
    }
  }, {
    key: "getFilterCount",
    value: function getFilterCount() {
      var count = 0;

      for (var filter in this.state.filters) {
        count += this.state.filters[filter].length;
      }

      return count;
    }
  }, {
    key: "removeFilter",
    value: function removeFilter(filter) {
      var _this12 = this;

      var newFilter;

      if (this.state.filters[filter.parameterName]) {
        newFilter = this.state.filters[filter.parameterName].filter(function (f) {
          return f.value !== filter.value;
        });
      }

      setTimeout(function () {
        _this12.setState(function (prev) {
          var newState = Object.assign({}, prev);
          newState.filters = Object.assign({}, prev.filters);
          newState.filters[filter.parameterName] = newFilter;
          return newState;
        }, function () {
          return _this12.setFilters(_this12.state.filters);
        });
      }, 10);
    }
  }, {
    key: "resetAllFilters",
    value: function resetAllFilters(noSearch) {
      this.setState(function (prev) {
        prev.filters = initialFilters();
        return prev;
      });
    }
  }, {
    key: "setFilters",
    value: function setFilters(filters, noSearch) {
      var t = this.props.t; // reset all filters if none are present (used for filter reset)

      if (Object.values(filters).every(function (filters) {
        return !filters.length;
      })) {
        this.resetAllFilters(noSearch);
      }

      var queryParts = [];
      Object.keys(filters).forEach(function (filter) {
        if (filters[filter].length === 0) return;

        if (filter !== 'project') {
          queryParts.push("".concat(filter, "=").concat(filters[filter].map(function (item) {
            return encodeURIComponent(item.value);
          }).join(',')));
        } else {
          queryParts.push("".concat(filter, "=").concat(filters[filter].map(function (item) {
            return t("".concat(item.filterKey, "-filter"));
          }).join(',')));
        }
      });
      var route = "/".concat(this.props.i18n.language);

      if (queryParts.length > 0) {
        route += '?' + queryParts.join('&');
      }

      if (this.props.iframe && this.props.iframe.isIframe && this.props.iframe.query.project === 'lgw') {
        route = '?iframe=1&iframe.query.project=lgw&' + queryParts.join('&');
      }

      if (noSearch) {
        route += '#home';
      }

      this.props.history.push(route);
    }
  }, {
    key: "setBrunchSoldout",
    value: function setBrunchSoldout() {
      var _this13 = this;

      // TODO: optimize code
      var soldOutValue = 0;

      if (this.state.filters.soldout.length > 0) {
        soldOutValue = 1;
      }

      var t = this.props.t;
      var filtersToSet = this.state.filters;

      if (!filtersToSet.project.length || filtersToSet.project.length > 1 || filtersToSet.project[0].value !== t('brunch-filter-value')) {
        filtersToSet.project = [{
          value: t('brunch-filter-value'),
          parameterName: 'project',
          filterKey: 'brunch'
        }];
      }

      filtersToSet.soldout = soldOutValue === 0 ? [{
        value: soldOutValue,
        parameterName: 'soldout'
      }] : [];
      setTimeout(function () {
        _this13.setState(function (prev) {
          prev.filters = filtersToSet;
          prev.detailViewPath = _this13.props.history.location.pathname;
          prev.detailViewSearch = _this13.props.history.location.search;
        }, function () {
          return _this13.search(false, true);
        });
      }, 10);
    }
  }, {
    key: "scrollToListStart",
    value: function scrollToListStart() {}
  }, {
    key: "getNumberOfResults",
    value: function getNumberOfResults() {
      var showResults = false;

      if (this.state.search !== '') {
        showResults = true;
      }

      if (!showResults && this.state.filters) {
        (0, _lodash3.default)(this.state.filters, function (filter) {
          if (filter.length > 0) {
            showResults = true;
            return true;
          }
        });
      }

      if (!showResults) {
        if (!(0, _lodash2.default)(this.props.iframe.query, {})) {
          showResults = true;
        }
      }

      return showResults ? this.props.totalFarms : NaN;
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(value) {
      this.setState({
        search: value
      });
      this.searchSuggestions(value);
    }
  }, {
    key: "checkViewportOffsetVisible",
    value: function checkViewportOffsetVisible() {
      // viewportOffsetStart is the title
      // viewportOffsetEnd is the "viewport-offset-pixel"
      // If one or the other is visible do not show the background of the search input
      // start is necessary because the pixel gets lost on certain devices on scrolling up due to some
      // "over scrolling"
      var refStart = this.viewportOffsetStartRef.current;
      var ref = this.viewportOffsetEndRef.current;

      if (!ref || !refStart) {
        return;
      }

      var viewportOffsetVisible = !!(0, _inViewport.default)(ref);
      var viewportOffsetStartVisible = !!(0, _inViewport.default)(refStart);

      if (this.state.viewportOffsetVisible !== viewportOffsetVisible) {
        this.setState({
          viewportOffsetVisible: viewportOffsetStartVisible || viewportOffsetVisible
        });
      }
    }
  }], [{
    key: "navToggle",
    value: function navToggle(e) {
      e.preventDefault();
      document.body.classList.toggle('nav-open');
    }
  }]);

  return Search;
}(_react.default.Component);

Search.propTypes = {
  dispatch: _propTypes.default.func,
  t: _propTypes.default.func.isRequired,
  menu: _propTypes.default.arrayOf(_propTypes.default.shape({
    url: _propTypes.default.string,
    onclick: _propTypes.default.func,
    link: _propTypes.default.string.isRequired,
    active: _propTypes.default.bool
  })),
  i18n: _propTypes.default.shape({
    language: _propTypes.default.string,
    changeLanguage: _propTypes.default.func
  }),
  lng: _propTypes.default.string,
  farms: _propTypes.default.array,
  totalFarms: _propTypes.default.number,
  locations: _propTypes.default.array,
  allLocations: _propTypes.default.array,
  loading: _propTypes.default.bool,
  loadMore: _propTypes.default.bool,
  history: _propTypes.default.shape({
    push: _propTypes.default.func.isRequired,
    location: _propTypes.default.shape({
      pathname: _propTypes.default.string,
      hash: _propTypes.default.string,
      search: _propTypes.default.string
    }),
    listen: _propTypes.default.func
  }),
  iframe: _propTypes.default.shape({
    query: _propTypes.default.object,
    isIframe: _propTypes.default.bool
  }),
  extSearch: _propTypes.default.shape({
    query: _propTypes.default.object,
    isExtSearch: _propTypes.default.bool
  }),
  search: _propTypes.default.string,
  activeFilter: _propTypes.default.any,
  theme: _propTypes.default.string,
  placeSearch: _propTypes.default.shape({
    name: _propTypes.default.string,
    lat: _propTypes.default.string,
    lon: _propTypes.default.string,
    show: _propTypes.default.bool
  }),
  coordinates: _propTypes.default.shape({
    lon: _propTypes.default.string,
    lat: _propTypes.default.string
  }),
  suggestions: _propTypes.default.shape({
    farms: _propTypes.default.array,
    products: _propTypes.default.array,
    locations: _propTypes.default.array
  }),
  allOutletLocations: _propTypes.default.array,
  outletsAll: _propTypes.default.array,
  project: _propTypes.default.array,
  showMap: _propTypes.default.bool,
  offersAvailability: _propTypes.default.array,
  vacation: _propTypes.default.array,
  product: _propTypes.default.array,
  searchInProgress: _propTypes.default.bool
};
/**
 * Maps state from redux to props of the component. use this only for container-component.
 *
 * @param state
 * @returns {{languages: Array|*|string[]}}
 */

var mapStateToProps = function mapStateToProps(state) {
  return (0, _lodash.default)({}, state.farm, {
    filters: state.searchFilter
  }, {
    extSearch: state.extSearch
  }, {
    iframe: state.iframe
  }, {
    shared: state.shared
  });
};

var _default = (0, _reactRedux.connect)(mapStateToProps)((0, _translate.default)(Search));

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./client/components/search/index.js
// module id = 280
// module chunks = 0